import { render } from "./Date.vue?vue&type=template&id=2bb45b53&lang=pug"
import script from "./Date.vue?vue&type=script&lang=ts"
export * from "./Date.vue?vue&type=script&lang=ts"
script.render = render

export default script